import Navigation from "../../header";
import { Container } from "@mui/material";
import { PowerBIEmbed } from 'powerbi-client-react';
import { IEmbedConfiguration, models } from 'powerbi-client';
import PermissionGate from "../../permissionGate";
import { useUserContext } from "../../../contexts/userContext";

const ShipmentHistoryReport = () => {
	var userContext = useUserContext();

	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext?.permissions?.canViewReportShipmentHistory}>
					<h1 className="report-header">Shipment History Report</h1>
					<embed width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=41d272c5-e0ed-44fd-a3a3-bcf709ec0ca4&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi"></embed>
				</PermissionGate>
			</Container>
		</>
	);
};

export default ShipmentHistoryReport;